export function branding({ game, team, xml, presToggle, kit }) {
  xml.payload.field.find((item) => {
    return item.attr.name === "0002"; // sub text
  }).value = !presToggle || !team ? 0 : 1;

  xml.payload.field.find((item) => {
    return item.attr.name === "000501"; // sub text
  }).value = !presToggle || !team ? 0 : 1;

  xml.payload.field.find((item) => {
    return item.attr.name === "000511"; // sub text
  }).value = 1;

  if (team) {
    try {
      xml.payload.field.find((item) => {
        return item.attr.name === "TeamColour"; // No. of subtext lines
      }).value = (team?.name + " " + kit)?.toUpperCase();
    } catch (err) {}
    let BGColour = team.variables?.[kit + "_clock_bg"];
    try {
      xml.payload.field.find((item) => {
        return item.attr.name === "000502"; // home team back colour
      }).value =
        "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/" + BGColour;
    } catch (err) {}

    try {
      let stripeColour = team?.variables?.[kit + "_kit_stripe_viz"];
      xml.payload.field.find((item) => {
        return item.attr.name === "000512"; // home team back colour
      }).value =
        "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/" +
        (stripeColour ?? BGColour);
    } catch (err) {}
  }
  return xml;
}

export function Colour_Tournament({ game, xml }) {
  xml.payload.field.find((item) => {
    return item.attr.name === "Colour_Tournament"; // sub text
  }).value = game?.competition?.variables?.sky_context;
  return xml;
}
